import { cn } from 'lib/utils'
import { TrendingDown, TrendingUp } from 'lucide-react'

const pct = new Intl.NumberFormat('it-IT', { maximumFractionDigits: 1 })

/** Signed % change with an arrow. Neutral ink: for some metrics down is good. */
const Change = ({ value, title }: { value: number | null; title?: string }) =>
  value == null ? null : (
    <span
      className='inline-flex items-center gap-1 text-xs text-muted-foreground tabular-nums'
      title={title}
    >
      {value >= 0 ? (
        <TrendingUp className='h-3 w-3' />
      ) : (
        <TrendingDown className='h-3 w-3' />
      )}
      {value > 0 ? '+' : ''}
      {pct.format(value)}%
    </span>
  )

/** A KPI: label, value, a footnote and an optional change. Selectable. */
export const MetricTile = ({
  label,
  value,
  note,
  change,
  changeTitle,
  title,
  selected,
  onSelect,
}: {
  label: string
  value: string
  note?: string
  change?: number | null
  changeTitle?: string
  title?: string
  selected?: boolean
  onSelect?: () => void
}) => {
  const body = (
    <>
      <div className='truncate text-xs text-muted-foreground'>{label}</div>
      <div className='mt-1 text-xl font-semibold tabular-nums'>{value}</div>
      <div className='flex flex-wrap items-center gap-x-2 text-[11px] text-muted-foreground'>
        {note && <span>{note}</span>}
        {change !== undefined && <Change value={change} title={changeTitle} />}
      </div>
    </>
  )
  const className = cn(
    'rounded-lg border bg-background p-3 text-left',
    onSelect && 'transition-colors hover:bg-accent',
    selected && 'border-primary ring-1 ring-primary'
  )

  return onSelect ? (
    <button
      type='button'
      aria-pressed={selected}
      onClick={onSelect}
      title={title}
      className={className}
    >
      {body}
    </button>
  ) : (
    <div className={className} title={title}>
      {body}
    </div>
  )
}
